import qs from 'qs';
import moment from 'moment';

import { RootState } from 'store/reducer';
import { resolveGetResourceTimeRangesParams } from 'utils/resolveGetResourceTimeRangesParams';
import { OwnerTypesEnum } from 'store/app-instance-configs/enums';
import { DEFAULT_OWNER_TYPE } from 'shared/consts';
import { parseQueryValue } from 'shared/utils/parse-query-value';
import { GetResourceTimeRangesParams } from 'store/resource-time-ranges/types';

export function buildResourceTimeRangesRefetchParams(state: RootState): GetResourceTimeRangesParams | null {
  const resourceId = state.resource?.resource?.id;
  if (resourceId == null) {
    return null;
  }

  const search = typeof window !== 'undefined' ? window.location.search : '';
  const query = qs.parse(search.replace(/^\?/, ''));
  const startDates = typeof query.startDates === 'string' ? query.startDates : undefined;

  const rawOwner = query.ownerType;
  const ownerType = rawOwner ? (parseQueryValue(String(rawOwner)).toLowerCase() as OwnerTypesEnum) : DEFAULT_OWNER_TYPE;

  if (startDates) {
    return resolveGetResourceTimeRangesParams({
      ownerType,
      resourceId,
      startDates,
    });
  }

  const startDate = moment().format('YYYY-MM-DD');
  const end = moment(startDate).add(1, 'days').format('YYYY-MM-DD');

  return resolveGetResourceTimeRangesParams({
    ownerType,
    resourceId,
    start: startDate,
    end,
  });
}
